<template>
  <div class="information-main">
    <div class="information-info">
      <div class="location">
        <img :src="require('../../assets/img/location.png')" alt="">
        当前位置：
        <template v-for="(item, index) in pathList">
          <span :key="index" class="location-name" @click="$router.push(item.path)">{{ item.name }}  </span> >
        </template>
        学堂资讯
      </div>
      <div class="section">
        <div class="section-title">
          学堂资讯
          <div class="bar" />
        </div>
        <div v-for="(item, index) in informationList" :key="index" class="information-item">
          <img :src="$urlPrefix + item.coverImg" alt="">
          <div class="content">
            <div class="title">
              <span @click="checkDetails(item.pkid)">{{ item.infoTitle }}</span>
            </div>
            <span class="time">{{ item.releaseTime }}</span>
            <div class="description">{{ item.societyProfile }}</div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        align="left"
        style="margin: 30px 30px"
        layout="total, prev, pager, next, jumper"
        :current-page="infoParams.pageNumber"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="infoParams.pageSize"
        :total="totalCount"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationMain',
  data() {
    return {
      pathList: [],
      currentPathList: [],
      infoParams: {
        pageNumber: 1,
        pageSize: 5
      },
      totalCount: 0,
      informationList: []
    }
  },
  created() {
    this.fetData()
    if (this.$route.query.pathList) {
      this.pathList = JSON.parse(this.$route.query.pathList)
      this.pathList = this.pathList.filter(item => item.name !== '学堂资讯')
      this.currentPathList = JSON.stringify([...this.pathList, {
        name: '学堂资讯',
        path: this.$route.fullPath
      }])
    }
  },
  methods: {
    fetData() {
      this.$post('/front/index/selectSocietyMore', this.infoParams).then(res => {
        if (res) {
          this.informationList = res.records
          this.totalCount = res.total
        } else {
          this.informationList = []
          this.totalCount = 0
        }
      })
    },
    handleCurrentChange(val) {
      this.infoParams.pageNumber = val
      this.fetData()
    },
    checkDetails(pkid) {
      this.$router.push({
        path: '/informationDetail',
        query: {
          pkid: pkid,
          pathList: this.currentPathList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.information-main {
  background-color: #F6F6F5;
  padding-top: 25px;
  .information-info {
    .location {
      width: 1200px;
      font-size: 14px;
      font-weight: 400;
      color: #363942;
      margin: 0 auto;

      img {
        vertical-align: middle;
        margin-right: 10px;
      }

      .location-name {
        cursor: pointer;
        color: darkgray;
      }

      .location-name:hover {
        color: #EA5504;
      }
    }
    .section {
      padding: 30px 0;
      background-color: #F6F6F6;
      margin: 0 auto;

      .section-title {
        width: 100%;
        height: 78px;
        font-size: 48px;
        font-family: YouSheBiaoTiHei;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        text-align: center;
      }

      .bar {
        width: 40px;
        height: 3px;
        background: #EA5504;
        margin: 15px auto 0 auto;
      }
      .information-item {
        margin: 20px auto 0 auto;
        width: 1200px;
        height: 164px;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;
        img {
          width: 200px;
          height: 124px;
          border-radius: 5px;
          display: inline-block;
        }
        .content {
          width: 920px;
          margin-left: 20px;
          display: inline-block;
          vertical-align: top;
          height: 124px;
          text-align: left;
          .title {
            font-size: 24px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis ;
            white-space: nowrap;
            color: #333333;
            margin-bottom: 15px;
            span {
              cursor: pointer;
            }
            span:hover {
              color: #EA5504;
            }
          }
          .time {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
          }
          .description {
            margin-top: 5px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis ;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }
      }
      .information-item:hover {
        box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
      }
    }
  }
}

</style>
